const downloadFileFromUrl = async ({ url, fileName }) => {
  if (!url) {
    throw new Error('URL файлу відсутній')
  }

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`Не вдалося завантажити файл (${response.status})`)
  }

  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = fileName || 'premium-catalog.xlsx'
  link.rel = 'noopener noreferrer'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
}

export default downloadFileFromUrl
